// API pública do módulo de exportação.

export { displayCell, rawCell, excelFormat, slugifyFilename, timestampForFilename } from "./formatters";
export { gerarPDF, salvarPDF, gerarBlobPDF } from "./pdfExporter";
export { gerarWorkbook, salvarExcel, gerarBlobExcel } from "./excelExporter";
export { salvarCSV, gerarBlobsCSV } from "./csvExporter";
export { salvarImagem, gerarBlobImagem } from "./imageExporter";
export {
  captureWithExpand,
  combineCanvasesVertical,
  motivoImagemInviavel,
  MAX_IMAGE_AREA_PX,
  MAX_IMAGE_HEIGHT_PX,
} from "./captureWithExpand";
export { resolverCorCss } from "./resolverCorCss";
export {
  marcaDaExportacao,
  FONTE_EXPORT_PADRAO,
  lerDensidadeAtual,
  montarTemaExportAtual,
} from "./temaExport";

export const FORMATOS_EXPORTACAO = [
  { id: "pdf",   label: "PDF estruturado",     descricao: "Tabelas em PDF multi-página com texto pesquisavel." },
  { id: "excel", label: "Excel (.xlsx)",       descricao: "Planilha com abas de dados + aba Resumo no final." },
  { id: "csv",   label: "CSV",                 descricao: "Arquivo separado por ; — Excel pt-BR friendly." },
  { id: "png",   label: "Imagem PNG",          descricao: "Imagem única contendo todas as seções visuais." },
  { id: "jpg",   label: "Imagem JPG",          descricao: "Igual ao PNG, com compressao." },
];

export const TIPOS_COLUNA = [
  "text", "number", "currency", "date", "days", "percentage", "status",
];
